module.exports = __webpack_public_path__ + "img/icon02.c4fa71a0.png";